import * as React from 'react';

import { Icon } from './Icon';
import { Text } from './Typography';
import { cn } from './cn';

// Vertical nav primitive. Two tones — `muted` (default, flat row with
// muted active state) and `primary` (card-style row with strong primary
// active state). Tone controls only paint; the wrapper is a minimal
// `flex-col gap-1` list either way. Caller owns any surrounding layout
// (column width, dividers, padding).

const TONE_VARIANTS = {
    muted: {
        item: 'tw-flex tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-gap-2.5 tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-left tw-transition-colors focus-visible:tw-outline-none',
        active: 'tw-bg-muted tw-font-medium tw-text-foreground',
        inactive: 'tw-text-muted-foreground hover:tw-bg-muted hover:tw-text-foreground',
        iconWrapper: 'tw-inline-flex tw-shrink-0 tw-justify-center'
    },
    primary: {
        item: 'tw-flex tw-w-full tw-cursor-pointer tw-select-none tw-items-start tw-gap-3 tw-rounded-2xl tw-border tw-px-4 tw-py-3 tw-text-left tw-transition-colors focus-visible:tw-outline-none',
        active: 'tw-border-primary tw-bg-primary tw-text-background',
        inactive: 'tw-border-transparent tw-bg-transparent tw-text-foreground hover:tw-border-border hover:tw-bg-muted',
        iconWrapper: 'tw-mt-0.5 tw-inline-flex tw-shrink-0 tw-justify-center'
    }
};

const resolveDescriptionTone = active => active ? 'inherit' : 'muted';

const SidebarMenu = ({
    items,
    onChange,
    tone = 'muted',
    value
}) => {
    const variant = TONE_VARIANTS[tone];

    return (
        <div className="tw-flex tw-flex-col tw-gap-1">
            {items.map(item => {
                const isActive = value === item.value;

                return (
                    <button
                        aria-current={isActive ? 'page' : undefined}
                        className={cn(variant.item, isActive ? variant.active : variant.inactive)}
                        data-value={item.value}
                        key={item.value}
                        onClick={() => onChange?.(item.value)}
                        type="button"
                    >
                        {item.icon ? (
                            <span className={variant.iconWrapper}>
                                <Icon icon={item.icon} size="small" tone="inherit" />
                            </span>
                        ) : null}
                        <span className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-1">
                            <Text tone="inherit" variant="control">{item.label}</Text>
                            {item.description ? (
                                <Text tone={resolveDescriptionTone(isActive)} variant="body-sm">
                                    {item.description}
                                </Text>
                            ) : null}
                        </span>
                        {item.trailing ? (
                            <span className="tw-ml-2 tw-inline-flex tw-shrink-0 tw-items-center">
                                {item.trailing}
                            </span>
                        ) : null}
                    </button>
                );
            })}
        </div>
    );
};

export { SidebarMenu };
